<black-bar-wrapper [class]="filterPage" [noClose]="true">
  <div class="header">
    <icon (click)="moveMonths(-1)" matIcon="keyboard_arrow_left"></icon>
    <div class="month-holder"><div class="month">{{ selectedDate | date:'MMMM y'}}</div></div>
    <icon (click)="moveMonths(1)" matIcon="keyboard_arrow_right"></icon>
    <div class="today" *ngIf="selectedDate?.getMonth() !== currentDate.getMonth()" (click)="backToday()">Today</div>
    <app-task-toggle-menu *ngIf="filterPage === 'tasksCalendar'" [showMarkAllRead]="false" [showDetailOptions]="false" [showSortOptions]="false" [lightDots]="true" [filterPage]="filterPage"></app-task-toggle-menu>
  </div>
  <div class="week_header">
    <div class="name" *ngFor="let d of weekDays; index as dayIndex; trackBy: trackByIndex"><span class="desktop">{{d}}</span><span class="mobile">{{ dayAbbr[dayIndex] }}</span></div>
  </div>
  <div class="calendar">
    <div class="desktop week" *ngFor="let week of weeks; first as first; trackBy: trackByIndex" [ngClass]="{ first: first }">
      <div class="day" *ngFor="let day of week; last as last; first as sunday; trackBy: trackByIndex" [ngClass]="{ last: last, grey: day.otherMonth}">
        <div class="date" >
          <label [ngClass]="{ selected: todayId === day.dateId, grey: day.otherMonth }">{{ day.day }}</label>
          <div class="hasEvent" *ngIf="isSingleEvent && eventDateIds.has(day.dateId)" (click)="viewEvent(event)">Event day</div>
        </div>
        <ng-container *ngIf="calendarEventsByDate[day.dateId] as calEvents">
          <div *ngFor="let calEvent of calEvents; trackBy: trackByCalendarEvent" class="event-holder"[ngClass]="{ background: calEvent }">
            <div class="event-wrapper" 
              *ngIf="calEvent && (sunday || calEvent.start) && events[calEvent.eventId] as event"
              (click)="viewEvent(event)"
              [ngClass]="{ start: calEvent.start, end: calEvent.endsInWeek }"
              [ngStyle]="{width: 'calc(' + 100 * calEvent.daySpan + '% - ' + 
              ((calEvent.endsInWeek ? 5 : 0) + (calEvent.start ? 5 : 0) - (calEvent.daySpan - 1)) +
              'px)'}"
            >
              <event-status [outsideEvent]="!isSingleEvent" [eventId]="event.eventId" [dotOnly]="true"></event-status>
              <div class="ellipsis">{{ event.title }}</div>
              <div style="flex:1;"></div>
              <label-dots *ngIf="event && event.labels && accountEventLabelMaps[event.accountId] as labelMap" [labelIds]="event.labels" [labelMap]="labelMap"></label-dots>
            </div>
          </div>
        </ng-container>
        <div class="tasks-wrapper" *ngIf="hasTasks">
          <ng-container *ngIf="tasksByDate[day.dateId] as taskList">
            <div *ngFor="let task of taskList; trackBy: trackById" class="task-holder" [ngClass]="{ completed: task.status === 'complete', inEvent: isSingleEvent }">
              <div class="task-absolute-holder" *ngIf="(isSingleEvent ? event : events[task.eventId]) as event" (click)="manageTask(task)">
                <div class="task-info">
                  <div class="name-icons">
                    <div class="task-name ellipsis">{{ task.name || 'Unnamed task'}}</div>
                    <div style="flex:1;"></div>
                    <label-dots [labelMap]="!isSingleEvent ? eventTasksLabelMaps[task.eventId] : taskLabels" [labelIds]="task.labels"></label-dots>
                    <icon class="flag" [i18]="true" *ngIf="task.flag" [icon]="'FLAGON18'"></icon>
                  </div>
                  <div *ngIf="!isSingleEvent" class="task-event-name ellipsis">{{ event.title || 'Unnamed Event' }}</div>
                </div>
              </div>
            </div>
          </ng-container>
          <div *ngIf="!readOnly && !isGuest" class="add-button" (click)="addTask(day.dateId, $event)">+ Add a task</div>
        </div>
      </div>
    </div>
    <div class="mobile tiny-week" *ngFor="let week of weeks; first as first; trackBy: trackByIndex" [ngClass]="{ first: first }">
      <div class="tiny-day" (click)="setDate(day.dateId)" *ngFor="let day of week; trackBy: trackByIndex">
        <div class="date"><label [ngClass]="{ selected: selectedDateId ? selectedDateId === day.dateId : todayId === day.dateId, grey: day.otherMonth }">{{ day.day }}</label></div>
        <div class="dot" *ngIf="!!calendarEventsByDate[day.dateId] || !!tasksByDate[day.dateId] || (isSingleEvent && eventDateIds.has(day.dateId))"></div>
      </div>
    </div>
  </div>      
</black-bar-wrapper>
<ng-container *ngIf="{ calEvents: calendarEventsByDate[selectedDateId] || [], taskList: tasksByDate[selectedDateId] || []} as vars">
  <div class="mobile day-holder" *ngIf="vars.calEvents.length || vars.taskList.length">
    <ng-container *ngFor="let calEvent of vars.calEvents">
      <div *ngIf="calEvent && events[calEvent.eventId] as event" class="event" (click)="viewEvent(event)">
        <div class="title ellipsis">{{ event.title || 'Unnamed event' }}</div>
        <div style="flex:1;"></div>
        <label-dots *ngIf="event.labels && accountEventLabelMaps[event.accountId] as labelMap" [labelIds]="event.labels" [labelMap]="labelMap"></label-dots>
      </div>
    </ng-container>
    <ng-container *ngFor="let task of vars.taskList">
      <div class="task" (click)="manageTask(task)">
        <icon [i18]="true" class="task-check" [icon]="task.status === 'complete' ? 'TASKCOMPLETE18' : 'TASKINCOMPLETE18'"></icon>
        <div class="title ellipsis">{{ task.name || 'Unnamed task' }}</div>
        <div style="flex:1;"></div>
        <label-dots *ngIf="task.labels" [labelMap]="!isSingleEvent ? eventTasksLabelMaps[task.eventId] : taskLabels" [labelIds]="task.labels"></label-dots>
        <icon class="flag" [i18]="true" *ngIf="task.flag" [icon]="'FLAGON18'"></icon>
      </div>
    </ng-container> 
  </div>
</ng-container>